import dayjs from 'dayjs';
import { useState } from 'react';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import duration from 'dayjs/plugin/duration';
import { useTranslation } from 'react-i18next';

import { api } from 'api';
import { useAlert } from 'hooks';
import { useCourseContext } from 'context';

import { Button } from '../button';

import { DownloadCertificateButtonProps } from './types';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);

export const DownloadCertificateButton = ({
  children,
  courseSubmissionId,
  ...props
}: DownloadCertificateButtonProps) => {
  const [isDownloading, setDownloading] = useState(false);
  const { handleError } = useAlert();
  const { t } = useTranslation(['common']);

  const { submissionId } = useCourseContext();

  const id = courseSubmissionId || submissionId;

  const onDownload = async () => {
    try {
      setDownloading(true);

      const response = await api.pdf.downloadCourseSubmissionPdf({
        id: String(id),
        timezone: dayjs.tz.guess(),
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));

      const a = document.createElement('a');
      a.href = url;
      a.download = 'Certificate.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      handleError(error);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Button
      onClick={onDownload}
      buttonClassName="px-5"
      disabled={!id || isDownloading}
      {...props}
    >
      {children || t('downloadCertificate')}
    </Button>
  );
};
